/**
 * SearchWordListContainer
 * --
 */
import React from 'react';
import SearchWordListPresenter from './SearchWordListPresenter';

const SearchWordListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <SearchWordListPresenter />
    </>
  );
};

export default SearchWordListContainer;
